import { FoodsTabs } from "@foodpilot/foods";
import type { FoodsIconProps } from "@foodpilot/foods";
import { useTheme } from "@mui/material";

export type ReferenceSourceTab<Value extends string> = {
    icon: FoodsIconProps["icon"];
    label: string;
    value: Value;
};

type ReferenceSourceTabsProps<Value extends string> = {
    ariaLabel: string;
    onChange: (value: Value) => void;
    tabs: ReferenceSourceTab<Value>[];
    value: Value;
};

export const ReferenceSourceTabs = <Value extends string>(props: ReferenceSourceTabsProps<Value>) => {
    const { ariaLabel, onChange, tabs, value } = props;
    const theme = useTheme();
    const selectedTabIndex = tabs.findIndex((tab) => tab.value === value);

    return (
        <FoodsTabs
            BoxProps={{ sx: { maxWidth: "100%", width: "max-content" } }}
            forceScrollable
            selectedTabIndex={selectedTabIndex}
            tabs={tabs.map((tab) => ({
                icon: tab.icon,
                id: tab.value,
                name: tab.label,
                TabProps: {
                    "aria-label": tab.label,
                },
            }))}
            tabVariant="buttons"
            TabProps={{
                sx: {
                    gap: theme.spacing(1),
                    height: theme.spacing(5),
                    margin: 0,
                    minHeight: theme.spacing(5),
                    paddingLeft: theme.spacing(1.5),
                    paddingRight: theme.spacing(2),
                    "& .MuiTab-icon": { margin: 0 },
                },
            }}
            TabsProps={{
                "aria-label": ariaLabel,
                onChange: (_event, nextIndex) => {
                    const nextTab = tabs[nextIndex];
                    if (nextTab !== undefined) onChange(nextTab.value);
                },
                slotProps: { list: { sx: { gap: theme.spacing(2) } } },
                sx: { minHeight: theme.spacing(5) },
            }}
        />
    );
};
